import { t } from '../lib/i18n';
import type { Visibility } from './api';

/**
 * What an empty CRM table should say, given how much of the tenant the reader may see.
 *
 * A salesperson holds `contacts:read` at `OWN` scope, so their list is filtered to records they own.
 * When every record belongs to somebody else the table is empty and — until this — said "no leads
 * yet", which is not what happened and sends the person to report a bug that is not one.
 *
 * Nothing here is a secret: the scope is the reader's own role, described back to them. It says what
 * they are seeing and who can widen it; it does not say how many records are hidden, which would be
 * a fact about other people's data.
 */
export function emptyFor(
  visibility: Visibility | undefined,
  fallback: { title: string; description?: string },
): { title: string; description?: string } {
  if (!visibility || visibility === 'ALL') return fallback;

  return {
    title: t('crm.scopedEmpty'),
    description: t(`crm.scopedEmpty.${visibility}`),
  };
}
